/** `?device=` din legaturile spre un aparat (Detections, Incidents, EDR events): un ID pozitiv, altfel nimic. */
export function deviceParam(raw: unknown): number | undefined {
  const value = typeof raw === 'number' ? raw : typeof raw === 'string' && /^\d+$/.test(raw) ? Number(raw) : NaN
  return Number.isSafeInteger(value) && value > 0 ? value : undefined
}

/** `?day=` din legatura "EDR events that day": o zi YYYY-MM-DD, altfel nimic. */
export function dayParam(raw: unknown): string | undefined {
  return typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(raw) ? raw : undefined
}

/** `?around=` din legatura "EDR events around 09:00": un moment YYYY-MM-DDTHH:MM[:SS] (UTC), cu secunde; altfel nimic. */
export function aroundParam(raw: unknown): string | undefined {
  const m = typeof raw === 'string' ? /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})(:\d{2})?$/.exec(raw) : null
  return m ? `${m[1]}${m[2] ?? ':00'}` : undefined
}
